import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import VueLazyload from 'vue-lazyload'
import 'view-design/dist/styles/iview.css'

Vue.use(ViewUI)
import '@/assets/css/common.less'

Vue.use(VueLazyload, {
  preLoad: 1.2,
  error: require('@/assets/images/default.png'),
  loading: require('@/assets/images/default.png'),
  attempt: 1
})

import common from '@/utils/commonFunctions'
Vue.prototype.common = common // 公共函数
// 公共组件
import SelectCategory from '@/components/SelectCategory'
Vue.component('select-category', SelectCategory)

import PageControl from '@/components/PageControl'
Vue.component('page-control', PageControl)

import NoResult from '@/components/NoResult'
Vue.component('no-result', NoResult)
import Loading from '@/components/NoResult/loading'
Vue.component('result-loading', Loading)

Vue.prototype.$Message.config({ // 弹窗设置
  top: 200,
  duration: 3
})
Vue.config.productionTip = false
/*
 * 定义常量
 */
let DOMAIN_URL = ''
let DOMAIN_USER_URL= ''
let ADMIN_URL = ''
let H5_URL = ''
/**
 * 开发环境和发布环境变量
 */
if (process.env.NODE_ENV === 'development') {
   //DOMAIN_URL = 'https://localhost:8080'
   //ADMIN_URL = 'https://supplier.test.cnxieku.com'
  //DOMAIN_URL = 'https://www.cnxieku.com'
 /* DOMAIN_URL = 'http://127.0.0.1:8401'
  DOMAIN_USER_URL = 'http://localhost:8080'*/
  DOMAIN_URL = 'https://www.cnxieku.com'
  DOMAIN_USER_URL = 'https://user.cnxieku.com'
  //ADMIN_URL = 'https://localhost:8091'
  ADMIN_URL = 'https://supplier.cnxieku.com'
  H5_URL = 'https://market.h5.cnxieku.com'
  console.log('开发环境')
} else {
  //DOMAIN_URL = 'https://market.ntest.cnxieku.com'
  // ADMIN_URL = 'https://supplier.test.cnxieku.com'
 /* DOMAIN_URL = 'http://127.0.0.1:8401'
  DOMAIN_USER_URL = 'http://localhost:8080'*/
  DOMAIN_URL = 'https://www.cnxieku.com'
  DOMAIN_USER_URL = 'https://user.cnxieku.com'
  //DOMAIN_URL = 'https://www.cnxieku.com'
  ADMIN_URL = 'https://supplier.cnxieku.com'
  H5_URL = 'https://market.h5.cnxieku.com'
  console.log('发布环境')
}
Vue.prototype.DOMAIN_URL = DOMAIN_URL
Vue.prototype.DOMAIN_USER_URL = DOMAIN_USER_URL
Vue.prototype.ADMIN_URL = ADMIN_URL
Vue.prototype.H5_URL = H5_URL

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
